// extracted by mini-css-extract-plugin
export default {"documentIcon":"styles_documentIcon__jpqTz","iconWrapper":"styles_iconWrapper__9+j+Y"};